<img [src]="currentBanner.image" alt="" style="height: 40px" />
<div class="d-flex align-items-center flex-fill" style="gap: 2rem; padding: 10px 0">
  <div [innerHTML]="currentBanner.description"></div>
  <div class="position-relative">
    <a [href]="acmAppUrl" target="_blank" class="btn btn-secondary bg-dark">{{ currentBanner.btnText }}</a>
    <img
      src="/assets/images/acm/hand-pointer.webp"
      alt=""
      class="position-absolute"
      style="height: 45px; bottom: -28px; left: 30%"
    />
  </div>
</div>
<div class="acm-logo-wrapper">
  <img src="/assets/images/acm-logo.svg" alt="" class="acm-logo" />
</div>
